import React, { useEffect, useState } from 'react';
import Icons from 'components/Icons';
import { makeStyles } from '@material-ui/core';
import api from 'api';
import { compose } from 'redux-starter-kit';
import selectors from 'store/selectors';
import { connect } from 'react-redux';
import actions from 'store/actions';
import Router from '../Router/Router';
import moment from 'moment';
import NotificationsRoundedIcon from '@material-ui/icons/NotificationsRounded';

const useStyles = makeStyles({
  container: {
    height: '69px',
    width: '69px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    transition: 'bottom 0.3s linear'
  },
  messageContainer: {
    height: '180px',
    width: '245px',
    position: 'absolute',
    left: '-180px',
    backgroundColor: '#dedede',
    border: '1px solid #dedede',
    borderRadius: '0 0 25px 25px',
    zIndex: -100,
    overflow: 'auto'
  },
  message: {
    border: '1px solid #eaeaea',
    width: '100%',
    minHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    padding: '4px',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  bubble: {
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    backgroundColor: 'red',
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center'
  },
  count: {
    color: 'white',
    fontWeight: 700
  },
  time: {
    opacity: 0.65,
    fontSize: '12px'
  }
});

const MessageCenter = ({ setMessages, messages }: any) => {
  const classes = useStyles();
  const { useHistory } = Router;
  const history = useHistory();
  const [hovering, setHovering] = useState(false);
  const [unread, setUnread] = useState(0);

  const deleteMessage = (e: any, id: number, index: number) => {
    e.stopPropagation();
    return api.deleteMessage(id).then(response => {
      if (response.status === 202) {
        const msgs = messages;
        msgs.splice(index, 1);
        setMessages([...msgs]);
      }
    });
  };

  const markAsRead = (id: number, index: number) => {
    return api.markAsRead(id).then(response => {
      if (response.status === 200) {
        const msgs = messages;
        msgs[index].read = true;
        setMessages([...msgs]);
      }
    });
  };

  const handleUnreadMessageUpdate = () => {
    const unreadMsgs = messages.reduce((count: number, msg: any) => {
      if (!msg.read) count += 1;
      return count;
    }, 0);
    // if (unreadMsgs !== 0 && unreadMsgs > unread) play();
    setUnread(unreadMsgs);
  };

  useEffect(() => {
    /* eslint-disable   react-hooks/exhaustive-deps */
    handleUnreadMessageUpdate();
  }, [messages]);
  /* eslint-enable   react-hooks/exhaustive-deps */

  return (
    <div
      className={classes.container}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <NotificationsRoundedIcon />
      {unread !== 0 && (
        <div className={classes.bubble}>
          <div className={classes.count}>{unread}</div>
        </div>
      )}
      <div
        className={classes.messageContainer}
        style={{ bottom: hovering ? '-178px' : '0px' }}
      >
        {messages.length === 0 && (
          <p style={{ margin: '12px' }}>
            There are currently no messages to display
          </p>
        )}
        {messages.map((message: any, index: number) => {
          return (
            <div
              onClick={() =>
                history.push(message.url || `/${message.meta}/questionnaire`)
              }
              onMouseEnter={() => {
                if (message.read === false) {
                  markAsRead(message.id, index);
                  const unreadMsg = unread - 1;
                  setUnread(unreadMsg);
                }
              }}
              className={classes.message}
              key={`msg_${index}`}
              style={{
                backgroundColor: message.read ? '#f9f9f9' : 'white',
                color: message.read ? '#a4a4a4' : 'black'
              }}
            >
              <div style={{ margin: '12px' }}>
                <div>{message.message}</div>
                <div className={classes.time}>
                  {moment(message.created_at).fromNow()}
                </div>
              </div>
              <Icons.DeleteIcon
                onClick={e => deleteMessage(e, message.id, index)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default compose(
  connect(
    (state: any) => ({
      messages: selectors.messagesSelectors.getMessages(state)
    }),
    {
      setMessages: actions.webSocketActions.setMessages
    }
  )
)(MessageCenter);
